import { render } from "./QuemSomosView.vue?vue&type=template&id=6cedf352"
import script from "./QuemSomosView.vue?vue&type=script&lang=js"
export * from "./QuemSomosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__